import {$} from '../constants'

export default function loading(timeout = 500) {
    const $loadingWindow = $('#loading-window');
    $loadingWindow.addClass('active');
    setTimeout(function() {
        $loadingWindow.removeClass('active')
    }, timeout);
}
